import { useState, useEffect, useCallback } from "react";

const GA4_STORAGE_KEY = "hj_ga4_measurement_id";

export function useGA4() {
  const [measurementId, setMeasurementIdState] = useState<string>(() => {
    return localStorage.getItem(GA4_STORAGE_KEY) || "";
  });
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(GA4_STORAGE_KEY);
    if (stored) {
      setMeasurementIdState(stored);
      setIsActive(true);
    }
  }, []);

  const saveMeasurementId = useCallback((id: string) => {
    const trimmed = id.trim();
    localStorage.setItem(GA4_STORAGE_KEY, trimmed);
    setMeasurementIdState(trimmed);
    setIsActive(!!trimmed);
  }, []);

  const removeMeasurementId = useCallback(() => {
    localStorage.removeItem(GA4_STORAGE_KEY);
    setMeasurementIdState("");
    setIsActive(false);
  }, []);

  return { measurementId, isActive, saveMeasurementId, removeMeasurementId };
}

export function getStoredGA4Id(): string {
  return localStorage.getItem(GA4_STORAGE_KEY) || "";
}
